import { stockTypeEnum } from "@gtpl/shared-models/common-models";
import { OccupancyEnum, RackPositionEnum, RackPositionTypeEnum } from "@gtpl/shared-models/masters";
import {Column,Entity,JoinColumn,ManyToOne,OneToMany,PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Rack } from "../racks/racks.entity";

@Entity('rack_position')
export class RackPosition {
  @PrimaryGeneratedColumn('increment', { name: 'rack_position_id' })
  rackPositionId: number;

  @Column("varchar",{
    nullable:false,
    length:20,
    name:"rack_code"
  })
  rackCode:string;

  @Column({
    type: 'enum',
    enum: RackPositionEnum,
    nullable: false,
    default: RackPositionEnum.BACK_CENTER,
    name: 'rack_position'
  })
  rackPosition: RackPositionEnum;

  @Column('int', {
    nullable: false,
    name: 'rack_level'
  })
  rackLevel: number;

  @Column('int', {
    nullable: false,
    name: 'rack_column'
  })
  rackColumn: number;

  @Column('int', {
    nullable: false,
    name: 'rack_id'
  })
  rackId: number;
  @Column('int', {
    nullable: false,
    name: 'zone_id'
  })
  zoneId: number;
  @Column("text", {
    nullable: false,
    name: "rack_boundaries"
  })
  rackBoundaries: string;

  @Column("text", {
    nullable: false,
    name: "assoc_rfid"
  })
  assocRfId: string;

  
  @Column('int', {
    nullable: false,
    name: 'plant_id'
  })
  plantId: number;
  @Column('int', {
    nullable: true,
    name: 'rack_position_code'
  })
  rackPositionCode: number;
  @Column('int', {
    nullable: true,
    name: 'rack_reserve_code'
  })
  rackReserveCode: number;

  @Column('int', {
    nullable: true,
    name: 'sale_order_id'
  })
  saleOrderId: number;
  @Column('int', {
    nullable: true,
    name: 'sale_order_item_id'
  })
  saleOrderItemId: number;
  @Column('int', {
    nullable: true,
    name: 'varient_id'
  })
  varientId: number;

  @Column({
    type: 'enum',
    enum: OccupancyEnum,
    nullable: false,
    default: OccupancyEnum.NOT_OCCUPIED,
    name: 'occupancy'
  })
  occupancy: OccupancyEnum;
  @Column({
    type: 'enum',
    enum: RackPositionTypeEnum,
    nullable: false,
    default: RackPositionTypeEnum.REAR,
    name: 'rack_position_type'
  })
  rackPositionType: RackPositionTypeEnum;
  @Column({
    type: 'enum',
    enum: stockTypeEnum,
    nullable: true,
    default: stockTypeEnum.SaleOrder,
    name: 'reserved_for'
  })
  reservedFor: stockTypeEnum;

  @Column('boolean', {
    nullable: false,
    default: false,
    name: 'is_reserved',
  })
  isReserved: boolean;

  @Column("date", {
    nullable: true,
    name: "reserved_date"
  })
  reservedDate: Date;

  @Column('boolean', {
    nullable: false,
    default: true,
    name: 'is_active',
  })
  isActive: boolean;

  @CreateDateColumn({
    name: 'created_at',
    type: 'datetime',
  })
  createdAt: Date;

  @Column('varchar', {
    nullable: false,
    name: 'created_user',
    length: 50,
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: 'updated_at',
    type: 'datetime',
  })
  updatedAt: Date;

  @Column('varchar', {
    nullable: true,
    name: 'updated_user',
    length: 50,
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: 'version_flag',
  })
  versionFlag: number;
  
  @ManyToOne(type => Rack, rack => rack.rackPositionInfo, { nullable: false, })
  @JoinColumn({ name: "rack_id" })
  rackMasterInfo: Rack;


}

